import { Component, OnInit } from '@angular/core';
import { SliderStepComponent } from '../../step/slider-step/slider-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-property-value',
  templateUrl: './property-value.component.html',
  styleUrls: ['./property-value.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class PropertyValueComponent extends SliderStepComponent implements OnInit {
  public enterFieldValue: number;
  public title: string = "Estimate home value";
  
  ngOnInit() {
    this.sliderValue = 44;

    this.sliderValues = [60000, 65000, 70000, 75000, 80000, 85000, 90000, 95000, 100000, 105000, 110000,
      115000, 120000, 125000, 130000, 135000, 140000, 145000, 150000, 155000, 160000, 165000, 170000, 175000, 180000, 185000, 190000, 195000,
      200000, 210000, 220000, 230000, 240000, 250000, 260000, 270000, 280000, 290000, 300000, 310000, 320000, 330000, 340000, 350000, 360000,
      370000, 380000, 390000, 400000, 420000, 440000, 460000, 480000, 500000, 520000, 540000, 560000, 580000, 600000, 620000, 640000, 660000,
      680000, 700000, 720000, 740000, 760000, 780000, 800000, 820000, 840000, 860000, 880000, 900000, 920000, 940000, 960000, 980000, 1000000,
      1100000, 1200000, 1300000, 1400000, 1500000, 1600000, 1700000, 1800000, 1900000, 2000000, 2000001];
    this.sliderLabels = ['Under $60,000', '$60,001 - $65,000', '$65,001 - $70,000', '$70,001 - $75,000', '$75,001 - $80,000', '$80,001 - $85,000', '$85,001 - $90,000',
      '$90,001 - $95,000', '$95,001 - $100,000', '$100,001 - $105,000', '$105,001 - $110,000', '$110,001 - $115,000', '$115,001 - $120,000',
      '$120,001 - $125,000', '$125,001 - $130,000', '$130,001 - $135,000', '$135,001 - $140,000', '$140,001 - $145,000', '$145,001 - $150,000',
      '$150,001 - $155,000', '$155,001 - $160,000', '$160,001 - $165,000', '$165,001 - $170,000', '$170,001 - $175,000', '$175,001 - $180,000',
      '$180,001 - $185,000', '$185,001 - $190,000', '$190,001 - $195,000', '$195,001 - $200,000', '$200,001 - $210,000', '$210,001 - $220,000',
      '$220,001 - $230,000', '$230,001 - $240,000', '$240,001 - $250,000', '$250,001 - $260,000', '$260,001 - $270,000', '$270,001 - $280,000',
      '$280,001 - $290,000', '$290,001 - $300,000', '$300,001 - $310,000', '$310,001 - $320,000', '$320,001 - $330,000', '$330,001 - $340,000',
      '$340,001 - $350,000', '$350,001 - $360,000', '$360,001 - $370,000', '$370,001 - $380,000', '$380,001 - $390,000', '$390,001 - $400,000',
      '$400,001 - $420,000', '$420,001 - $440,000', '$440,001 - $460,000', '$460,001 - $480,000', '$480,001 - $500,000', '$500,001 - $520,000',
      '$520,001 - $540,000', '$540,001 - $560,000', '$560,001 - $580,000', '$580,001 - $600,000', '$600,001 - $620,000', '$620,001 - $640,000',
      '$640,001 - $660,000', '$660,001 - $680,000', '$680,001 - $700,000', '$700,001 - $720,000', '$720,001 - $740,000', '$740,001 - $760,000',
      '$760,001 - $780,000', '$780,001 - $800,000', '$800,001 - $820,000', '$820,001 - $840,000', '$840,001 - $860,000', '$860,001 - $880,000',
      '$880,001 - $900,000', '$900,001 - $920,000', '$920,001 - $940,000', '$940,001 - $960,000', '$960,001 - $980,000', '$980,001 - $1,000,000',
      '$1,000,001 - $1,100,000', '$1,100,001 - $1,200,000', '$1,200,001 - $1,300,000', '$1,300,001 - $1,400,000', '$1,400,001 - $1,500,000',
      '$1,500,001 - $1,600,000', '$1,600,001 - $1,700,000', '$1,700,001 - $1,800,000', '$1,800,001 - $1,900,000', '$1,900,001 - $2,000,000',
      'Over $2,000,000'];

    this.sliderDisplay = this.sliderLabels[this.sliderValue];
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('propertyValue', this.control);

    this.fruHttpService.getMedian().subscribe((response: any) => {
      this.setSlideByPrice(response.price);
    });
  }

  slide(e) {
    this.sliderValue = e.target.value;
    this.sliderDisplay = this.sliderLabels[e.target.value];
    if (this.sliderDisplay === 'Under $60,000') {
      this.enterFieldValue = null;
    } else {
      this.enterFieldValue = this.sliderValues[this.sliderValue];
    }

    //add commas to numeric inputs
    this.enterStringFieldValue = this.sliderValues[this.sliderValue].toLocaleString();
  }

  setSlideByPrice(price, setEnterString = false) {
    this.enterFieldValue = isNaN(price) ? 0 : price;

    if (setEnterString) {
      //add commas to numeric inputs
      this.enterStringFieldValue = this.enterFieldValue.toLocaleString();
    }

    let diff = 0;
    if (this.enterFieldValue <= 200000) {
      diff = 5000;
    } else if (this.enterFieldValue <= 400000) {
      diff = 10000;
    } else if (this.enterFieldValue <= 1000000) {
      diff = 20000;
    } else {
      diff = 100000;
    }

    for (var i = 0; i < this.sliderValues.length; i++) {
      if (((this.sliderValues[i] - diff) < this.enterFieldValue || this.enterFieldValue < 60000)
        && (this.sliderValues[i + 1] == undefined || (this.sliderValues[i + 1] - diff) >= this.enterFieldValue)) {
        this.sliderValue = this.sliderValues[i + 1] == undefined && this.sliderValues[i] > this.enterFieldValue ? i - 1 : i;
        break;
      }
    }

    this.sliderDisplay = this.sliderLabels[this.sliderValue];
  }

  setSlide(e) {
    let value = parseFloat(e.target.value.replace(/,/g, ''));
    this.setSlideByPrice(value, true);
  }

  countVisitorAction() {
    this.form.controls.propertyValueAction.setValue('1');
  }
}
